export const clientPath = 'CLIENTPATH';

export function setClientPath(thisClientPath) {

  return { type: clientPath, thisClientPath }
}


// WEBPACK FOOTER //
// ./src/actions/clientPath.js